import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["id", "points"]

import { PropType, ref, computed, onMounted, onBeforeUnmount } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LineGraph',
  props: {
  color: {
    type: String,
    default: 'black'
  },

  data: {
    type: Array as PropType<Array<number[]>>,
    required: true
  },

  strokeWidth: {
    type: Number,
    default: 2
  }
},
  setup(__props) {

const props = __props;



const id = ref(Math.random() + Date.now())
const root = ref(undefined)
const width = ref(0)
const height = ref(0)
const ro = ref(undefined as unknown as ResizeObserver)
const observedElement = ref(undefined as HTMLElement | null | undefined)

onMounted(() => {
  ro.value = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.contentRect) {
        width.value = entry.contentRect.width
        height.value = entry.contentRect.height
      }
    }
  })

  const rootEl = root.value as HTMLElement | undefined
  if (!rootEl) {
    return
  }

  observedElement.value = rootEl.parentElement
  ro.value.observe(observedElement.value as Element)
})

onBeforeUnmount(() => {
  ro.value.unobserve(observedElement.value as Element)
})

const polyfillPoints = computed(() => {
  const maxX = Math.max(...props.data.map((p: any) => p[0]))
  const maxY = Math.max(...props.data.map((p: any) => p[1]))
  const minY = Math.min(...props.data.map((p: any) => p[1]))

  return props.data.reduce((points, [x, y]) => {
    const pointXInWidth = (x / maxX) * width.value
    const pointYInHeight =
      height.value - ((y - minY) / (maxY - minY)) * height.value

    return `${points} ${pointXInWidth},${pointYInHeight}`
  }, '')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "chart",
    ref_key: "root",
    ref: root,
    width: width.value,
    height: height.value,
    viewBox: `0 0 ${width.value} ${height.value}`,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("polyline", {
      id: `${id.value}`,
      points: _unref(polyfillPoints),
      style: _normalizeStyle([{"fill":"none","stroke-width":"1"}, { stroke: __props.color, 'stroke-width': __props.strokeWidth }])
    }, null, 12, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})